module.exports = __webpack_public_path__ + "img/start_academy_kn.974b2d66.png";